/**
 * Vista: Dashboard Principal
 * Resumen ejecutivo del sistema
 */

import dashboardService from '../services/dashboard.service.js';
import router from '../router/router.js';

export default {
  data: {
    resumen: null,
    actividad: []
  },

  async render() {
    return `
      <div class="dashboard">
        <div class="card" style="margin-bottom: 1.5rem;">
          <div class="card-header">
            <h2 class="card-title">Dashboard - Resumen Ejecutivo</h2>
          </div>

          <!-- Resumen de Tractores -->
          <div style="margin-bottom: 2rem;">
            <h3 style="margin-bottom: 1rem;">Estado de Tractores</h3>
            <div id="tractoresStats" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem;">
              <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
                <div class="stat-value" id="statTotal" style="font-size: 2rem; font-weight: bold;">-</div>
                <div class="stat-label" style="color: var(--text-muted);">Total Tractores</div>
              </div>
              <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
                <div class="stat-value" id="statAlmacen" style="font-size: 2rem; font-weight: bold; color: var(--info);">-</div>
                <div class="stat-label" style="color: var(--text-muted);">En Almacén</div>
              </div>
              <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
                <div class="stat-value" id="statProduccion" style="font-size: 2rem; font-weight: bold; color: var(--warning);">-</div>
                <div class="stat-label" style="color: var(--text-muted);">En Producción</div>
              </div>
              <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
                <div class="stat-value" id="statLiberados" style="font-size: 2rem; font-weight: bold; color: var(--primary);">-</div>
                <div class="stat-label" style="color: var(--text-muted);">Liberados</div>
              </div>
              <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
                <div class="stat-value" id="statEntregados" style="font-size: 2rem; font-weight: bold; color: var(--success);">-</div>
                <div class="stat-label" style="color: var(--text-muted);">Entregados</div>
              </div>
            </div>
          </div>

          <!-- Mes Actual -->
          <div style="margin-bottom: 2rem;">
            <h3 style="margin-bottom: 1rem;">Actividad del Mes</h3>
            <div id="mesStats" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
              <div class="stat-card" style="background: linear-gradient(135deg, var(--info), var(--primary)); padding: 1.5rem; border-radius: 8px; text-align: center; color: white;">
                <div class="stat-value" id="statRecepcionesMes" style="font-size: 2.5rem; font-weight: bold;">-</div>
                <div class="stat-label">Recepciones</div>
              </div>
              <div class="stat-card" style="background: linear-gradient(135deg, var(--warning), #f59e0b); padding: 1.5rem; border-radius: 8px; text-align: center; color: white;">
                <div class="stat-value" id="statLiberacionesMes" style="font-size: 2.5rem; font-weight: bold;">-</div>
                <div class="stat-label">Liberaciones</div>
              </div>
              <div class="stat-card" style="background: linear-gradient(135deg, var(--success), #10b981); padding: 1.5rem; border-radius: 8px; text-align: center; color: white;">
                <div class="stat-value" id="statEntregasMes" style="font-size: 2.5rem; font-weight: bold;">-</div>
                <div class="stat-label">Entregas</div>
              </div>
            </div>
          </div>

          <!-- Alertas -->
          <div style="margin-bottom: 2rem;">
            <h3 style="margin-bottom: 1rem;">Alertas y Pendientes</h3>
            <div id="alertasContainer" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
              <div id="alertaPNC" class="alert-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; border-left: 4px solid var(--danger); cursor: pointer;" onclick="router.navigate('/calidad/pnc')">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div>
                    <div style="font-weight: bold; color: var(--danger);">PNC Críticos</div>
                    <div style="color: var(--text-muted); font-size: 0.875rem;">Productos no conformes pendientes</div>
                  </div>
                  <div id="statPNCCriticos" style="font-size: 2rem; font-weight: bold; color: var(--danger);">-</div>
                </div>
              </div>
              <div id="alertaGarantias" class="alert-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; border-left: 4px solid var(--warning); cursor: pointer;" onclick="router.navigate('/posventa/reportes-garantia')">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div>
                    <div style="font-weight: bold; color: var(--warning);">Garantías Abiertas</div>
                    <div style="color: var(--text-muted); font-size: 0.875rem;">Reportes de garantía sin cerrar</div>
                  </div>
                  <div id="statGarantiasAbiertas" style="font-size: 2rem; font-weight: bold; color: var(--warning);">-</div>
                </div>
              </div>
              <div id="alertaOrdenes" class="alert-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; border-left: 4px solid var(--info); cursor: pointer;" onclick="router.navigate('/produccion/ordenes-trabajo')">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div>
                    <div style="font-weight: bold; color: var(--info);">Órdenes Pendientes</div>
                    <div style="color: var(--text-muted); font-size: 0.875rem;">Órdenes de trabajo por completar</div>
                  </div>
                  <div id="statOrdenesPendientes" style="font-size: 2rem; font-weight: bold; color: var(--info);">-</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Actividad Reciente -->
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Actividad Reciente</h3>
          </div>
          <div id="actividadContainer" style="max-height: 400px; overflow-y: auto;">
            <div style="text-align: center; padding: 2rem; color: var(--text-muted);">
              Cargando actividad...
            </div>
          </div>
        </div>
      </div>
    `;
  },

  async afterRender() {
    window.dashboardView = this;
    await this.cargarDatos();
  },

  async cargarDatos() {
    try {
      // Cargar resumen general
      const resumenResponse = await dashboardService.obtenerResumenGeneral();
      const resumen = resumenResponse.data || resumenResponse;

      // Actualizar estadísticas de tractores
      document.getElementById('statTotal').textContent = resumen.tractores?.total || 0;
      document.getElementById('statAlmacen').textContent = resumen.tractores?.en_almacen || 0;
      document.getElementById('statProduccion').textContent = resumen.tractores?.en_produccion || 0;
      document.getElementById('statLiberados').textContent = resumen.tractores?.liberados || 0;
      document.getElementById('statEntregados').textContent = resumen.tractores?.entregados || 0;

      // Actualizar mes actual
      document.getElementById('statRecepcionesMes').textContent = resumen.mes_actual?.recepciones_mes || 0;
      document.getElementById('statLiberacionesMes').textContent = resumen.mes_actual?.liberaciones_mes || 0;
      document.getElementById('statEntregasMes').textContent = resumen.mes_actual?.entregas_mes || 0;

      // Actualizar alertas
      document.getElementById('statPNCCriticos').textContent = resumen.alertas?.pnc_criticos || 0;
      document.getElementById('statGarantiasAbiertas').textContent = resumen.alertas?.garantias_abiertas || 0;
      document.getElementById('statOrdenesPendientes').textContent = resumen.alertas?.ordenes_pendientes || 0;

      // Cargar actividad reciente
      await this.cargarActividadReciente();
    } catch (error) {
      console.error('Error al cargar dashboard:', error);
      toast.error('Error al cargar datos del dashboard');
    }
  },

  async cargarActividadReciente() {
    try {
      const response = await dashboardService.obtenerActividadReciente(15);
      const actividad = response.data || response;

      const container = document.getElementById('actividadContainer');

      if (!actividad || actividad.length === 0) {
        container.innerHTML = `
          <div style="text-align: center; padding: 2rem; color: var(--text-muted);">
            No hay actividad reciente
          </div>
        `;
        return;
      }

      container.innerHTML = `
        <div style="display: flex; flex-direction: column; gap: 0.5rem;">
          ${actividad.map(a => `
            <div style="display: flex; align-items: center; gap: 1rem; padding: 0.75rem; background: var(--bg-secondary); border-radius: 4px;">
              <div style="width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: ${this.getTipoColor(a.tipo)}; color: white; font-size: 1.25rem;">
                ${this.getTipoIcon(a.tipo)}
              </div>
              <div style="flex: 1;">
                <div style="font-weight: 500;">${a.descripcion}</div>
                <div style="font-size: 0.875rem; color: var(--text-muted);">
                  ${a.referencia} - ${new Date(a.fecha).toLocaleDateString('es-MX')}
                </div>
              </div>
            </div>
          `).join('')}
        </div>
      `;
    } catch (error) {
      console.error('Error al cargar actividad:', error);
    }
  },

  getTipoIcon(tipo) {
    const iconos = {
      recepcion: '📦',
      liberacion: '🚜',
      entrega: '✅',
      pnc: '⚠️'
    };
    return iconos[tipo] || '📋';
  },

  getTipoColor(tipo) {
    const colores = {
      recepcion: 'var(--info)',
      liberacion: 'var(--warning)',
      entrega: 'var(--success)',
      pnc: 'var(--danger)'
    };
    return colores[tipo] || 'var(--secondary)';
  }
};
